// Small colored badge indicating a vehicle's real-time operational status.
// Backend fills `operational_status` on each vehicle payload (available | on_trip | unavailable).
export function VehicleStatusBadge({ status, size = "sm", className = "" }) {
  const s = status || "available";
  const { color, bg, ring, dot, label } = {
    available:   { color: "#065F46", bg: "#DCFCE7", ring: "#10B981", dot: "#10B981", label: "Disponible" },
    on_trip:     { color: "#854D0E", bg: "#FEF9C3", ring: "#FACC15", dot: "#EAB308", label: "En course"  },
    unavailable: { color: "#991B1B", bg: "#FEE2E2", ring: "#EF4444", dot: "#EF4444", label: "Indisponible" },
  }[s] || { color: "#334155", bg: "#F1F5F9", ring: "#94A3B8", dot: "#94A3B8", label: s };

  const pad = size === "lg" ? "px-3 py-1 text-[11px]" : "px-2.5 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-wide ${pad} ${className}`}
      style={{ color, background: bg, boxShadow: `inset 0 0 0 1px ${ring}66` }}
      data-testid={`vehicle-status-${s}`}
      title={label}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: dot }} />
      {label}
    </span>
  );
}

// Left-edge color strip variant for card top-left corner (like a "voyant / bandeau")
export function VehicleStatusStrip({ status, className = "" }) {
  const color = {
    available:   "#10B981",
    on_trip:     "#EAB308",
    unavailable: "#EF4444",
  }[status] || "#94A3B8";
  return (
    <span
      className={`absolute top-0 left-0 w-1.5 h-full ${className}`}
      style={{ background: color }}
      aria-hidden="true"
      data-testid={`vehicle-status-strip-${status || "unknown"}`}
    />
  );
}
